export enum PdfBackgroundType {
    PICKUP_TICKET = 'pickupticket',
    BARCODE_TICKET = 'barcodeticket',
    ETICKET = 'eticket',
    INVOICE = 'invoice',
}

export enum PdfBackgroundScope {
    OPERATOR_DEFAULT = 'OPERATOR_DEFAULT',
    OPERATOR_PRODUCT = 'OPERATOR_PRODUCT',
    USER_DEFAULT = 'USER_DEFAULT',
    USER_PRODUCT = 'USER_PRODUCT',
}

export type PdfBackground = {
    type: PdfBackgroundType;
    scope: PdfBackgroundScope;
    userId: string | null;
    shortProductId: string | null;
    storagePath: string;
};

export type PdfBackgroundsResponse = {
    liftOperatorId: string;
    backgrounds: PdfBackground[];
};

export const PDF_BACKGROUND_TYPE_LABELS: Record<PdfBackgroundType, string> = {
    [PdfBackgroundType.PICKUP_TICKET]: 'Pick-Up-Voucher',
    [PdfBackgroundType.BARCODE_TICKET]: 'Barcodeticket',
    [PdfBackgroundType.ETICKET]: 'Smartphoneticket',
    [PdfBackgroundType.INVOICE]: 'Rechnung',
};

export const PDF_BACKGROUND_SCOPE_LABELS: Record<PdfBackgroundScope, string> = {
    [PdfBackgroundScope.OPERATOR_DEFAULT]: 'Bergbahn-Standard',
    [PdfBackgroundScope.OPERATOR_PRODUCT]: 'Bergbahn · Produkt',
    [PdfBackgroundScope.USER_DEFAULT]: 'B2B-User',
    [PdfBackgroundScope.USER_PRODUCT]: 'B2B-User · Produkt',
};

export const TICKET_PDF_BACKGROUND_TYPES: PdfBackgroundType[] = [
    PdfBackgroundType.ETICKET,
    PdfBackgroundType.PICKUP_TICKET,
    PdfBackgroundType.BARCODE_TICKET,
];

export const SHORT_PRODUCT_ID_REGEX = /^[A-Za-z0-9_.-]+$/;
